module.exports = __webpack_public_path__ + "media/en-038c4067.svg";